import Logger from 'js-logger';
import _ from 'underscore';

/////////////////////////////////////////////////////////////////////////
// GameSizeManager //////////////////////////////////////////////////////////
/////////////////////////////////////////////////////////////////////////
const GameSizeManager = {

  pendingResize: false,
  ignoreResize: false,

  init: function(game, config, debug) {

    this.game = game;
    this.config = config;
    this.debug = debug;

    return this;
  },

  scaleManagerReady: function() {

    // Maintain aspect ratio & center
    this.game.scale.scaleMode = Phaser.ScaleManager.SHOW_ALL;
    this.game.scale.pageAlignHorizontally = true;
    this.game.scale.pageAlignVertically = true;

    // handle orientation changes
    this.game.scale.onOrientationChange.add(this.handleOrientationChange, this);
    this.game.scale.onSizeChange.add(this.handleGameSizeChanged, this);

    // handle browser resizes
    if (this.game.device.desktop)
    {
      // all this stuff just means don't call resizeGame until user stops dragging window around
      var lazyLayout = _.debounce(_.bind(this.resizeGame, this), 300);      
      window.addEventListener('resize', lazyLayout);

      // using jquery:
      //$(window).resize(lazyLayout);
    }

    

  },


  resizeGame: function() {

    if (this.ignoreResize)
      return;

    // need to use aspect ratio of window.innerWidth / window.innerHeight
    var aspectRatio = window.innerWidth / window.innerHeight;
    var idealAspectLandscape = this.config.minWidthLandscape / this.config.minHeightLandscape;
    var idealAspectPortait = this.config.minWidthPortrait / this.config.minHeightPortrait;

    // TODO - need to use outerHeight for android!?
    // maybe if outerHeight < innerHeight, use outerHeight
    // trying to avoid problem where top of game is underneath the status bar
    var newWidth = window.innerWidth;
    var newHeight = window.innerHeight;

    if (this.game.device.desktop)
    {
      // force portrait
      if (window.forcePortrait)
      {
        this.game.scale.setGameSize(this.config.minWidthPortrait, this.config.minHeightPortrait); 
      }      
      else
      {
        if (newHeight < this.config.minHeightLandscape)
        {
          // stick it to a minimum height
          this.game.scale.setGameSize(this.config.minWidthLandscape * aspectRatio / idealAspectLandscape, this.config.minHeightLandscape);     
        }
        else
        {
          this.game.scale.setGameSize(newWidth, newHeight);
        }
      }
      

    }
    else
    {
      // on mobile phones, fill the screen
      if (this.game.scale.isLandscape)
      {
        if (newHeight <= this.config.minHeightLandscape)
        {
          this.game.scale.setGameSize(Math.round(this.config.minWidthLandscape * aspectRatio / idealAspectLandscape), this.config.minHeightLandscape);
        }
        else
        {
          // use the device innerWidth - we need to do this because the iPad started reporting 704 for its height
          this.game.scale.setGameSize(newWidth, newHeight);
        }
      }
      else
      {
        this.game.scale.setGameSize(this.config.minWidthPortrait, Math.round(this.config.minHeightPortrait * idealAspectPortait / aspectRatio));     
      }

    }

Logger.info('resizeGame '+window.innerWidth+' '+window.innerHeight+' '+window.devicePixelRatio+' '+this.game.width+' '+this.game.height);       
  
    // remove priming timer
    if (this.game.resizeTimer) {

      this.game.resizeTimer.stop();
      this.game.resizeTimer = null;

    }
  },

  handleOrientationChange: function() {

    //console.log('handleOrientationChange');

    // delay for changes to percolate on iOS 9
    if (this.game.device.mobileSafari && this.game.device.iOSVersion > 8 && this.game.scale.isPortrait) {

      setTimeout(this.resizeGame.bind(this), 500);  
    }
    else {

      this.pendingResize = true;
    }
    

  },
  
  handleGameSizeChanged: function() {


    //Logger.info('game resized-SizeManager '+this.pendingResize+' '+this.game.width+' '+this.game.height+' '+this.game.scale.scaleFactor.x+' '+this.game.scale.scaleFactor.y+' '+this.game.scale.parentScaleFactor.x+' '+this.game.scale.parentScaleFactor.y);
    
    if (this.pendingResize) {

      this.resizeGame();
      this.pendingResize = false;
    }
    // do we need this??
    //this.game.scale.refresh();

  }, 

  handleResizeTimerTick: function(startingWidth, startingHeight) {

    // if current width/height is different, trigger a resize
    if (startingWidth !== window.innerWidth || startingHeight !== window.innerHeight) {

      Logger.info('INTERCEPT window size changed', startingWidth, startingHeight, '->', window.innerWidth, window.innerHeight);
      this.resizeGame();
    }
  }
};

Object.defineProperty(GameSizeManager, 'isLandscape', {

  get: function () {

    // shortcut - to let us override if needed
    return (this.debug && this.debug.forcePortrait) ? false : this.game.scale.isLandscape;

  },

  set: function (value) {


  }

});

Object.defineProperty(GameSizeManager, 'isPortrait', {

    get: function () {

      // shortcut - to let us override if needed
      return !this.isLandscape;

    },

    set: function (value) {


    }

});

export default GameSizeManager;







// WEBPACK FOOTER //
// ./app/src/utils/display/GameSizeManager.js